import React from 'react';

import { Grid, Paper } from '@mui/material';

import SpectrumMixerChannelSettingsItem, { MixerChannel } from './SpectrumMixerChannelSettingsItem';

interface SpectrumMixerChannelSettingsGridProps {
    lightChannels: MixerChannel[];
    onSliderChange: (channelId: string, value: number) => void;
    onIntensityChange: (channelId: string, value: number) => void;
    formData: Record<string, unknown>;
}

const SpectrumMixerChannelSettingsGrid = ({ lightChannels, onSliderChange, onIntensityChange, formData }: SpectrumMixerChannelSettingsGridProps) => (
    <>
        {lightChannels.map((channel) => {
            if (!channel.spectrogram || channel.intensityPercent === undefined) {
                return null;
            }

            return (
                <Grid key={channel.id} item container xs={12} md={6} lg={6} alignItems="stretch">
                    <Paper elevation={3} style={{ padding: '20px', marginBottom: '10px', display: 'flex', alignItems: 'stretch' }}>
                        <SpectrumMixerChannelSettingsItem
                            channel={channel}
                            formData={formData}
                            onIntensityChange={onIntensityChange}
                            onSliderChange={onSliderChange}
                        />
                    </Paper>
                </Grid>
            );
        })}
    </>
);

export default React.memo(SpectrumMixerChannelSettingsGrid);
